import { CustomButton, DialogHeader, HocElDialog, HocElDialogFooterLayout, UiUtils } from 'ui-components'

import { useI18n } from 'i18n-utils'
import { useSpotOrderListStore } from 'store'

export const CancelOrder = defineComponent({
  props: {
    order: {
      type: Object as PropType<ApiResponse.SpotOrderItem>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()
    const showCancelOrderDialog = ref(false)
    const spotOrderListStore = useSpotOrderListStore()
    const onCancelOrder = () => {
      showCancelOrderDialog.value = true
    }

    const onClose = () => {
      showCancelOrderDialog.value = false
    }

    const onSubmitCancel = async () => {
      const isSuccess = await spotOrderListStore.onCancelOrder(props.order.trustId)
      if (isSuccess) {
        showCancelOrderDialog.value = false
        UiUtils.showSuccess(t('撤单成功'))
      }
      showCancelOrderDialog.value = false
    }

    return () => (
      <>
        <span class={'cancel-order'} onClick={onCancelOrder}>
          {t('撤单')}
        </span>
        <HocElDialog v-model={showCancelOrderDialog.value} showClose={false} width={400} placement={'bottom'}>
          {{
            header: () => {
              return <DialogHeader onClose={onClose}>{t('撤单')}</DialogHeader>
            },
            default: () => {
              return (
                <div class="!py-[16px]">
                  <p>{t('确认撤销此订单？')}</p>
                </div>
              )
            },
            footer: () => {
              return (
                <HocElDialogFooterLayout>
                  <CustomButton type="primary" loading={spotOrderListStore.loading} onClick={onSubmitCancel}>
                    {t('确定')}
                  </CustomButton>
                  <CustomButton class={'cancel'} onClick={() => (showCancelOrderDialog.value = false)}>
                    {t('取消')}
                  </CustomButton>
                </HocElDialogFooterLayout>
              )
            },
          }}
        </HocElDialog>
      </>
    )
  },
})
